import { all, call, put, takeEvery } from 'redux-saga/effects'
import { globalLoaderText } from "redux/CommonDashboard/actions";
import { setReasonCode, setRequisitionReasonCode } from 'Store/OrderManagement/ReasonCode/ReasonCodeAction';
import { GET_REASON_CODE, GET_REQUISITION_REASON_CODE } from 'Store/OrderManagement/ReasonCode/ReasonCodeType';
import OrderManagementApiService from './OrderManagementApiService';
import { API_URL, apiMethod, apiType } from 'utils';
import { IPayload } from 'Model/IPayload';

function* getReasonCode(): any {
    try {
        yield put(globalLoaderText("Fetching Reason Code...."));
        let payloadData : IPayload = {
            apiType : apiType.OrderManagement,
            endpoint :  `orders/disposition/reasonCodes`,
            apiMethod :  apiMethod.GET,
            payload : null
            
           }
        const response = yield call(
            OrderManagementApiService.post,API_URL.PostWebApp,payloadData
           
        );

        if (response) {
            yield put(setReasonCode(response));
            yield put(globalLoaderText(""));
        }

    } catch (error) {
        yield put(setReasonCode([]))
        yield put(globalLoaderText(""));
    }
}

function* getRequisitionReasonCode(): any {
    try {
        let payloadData : IPayload = {
            apiType : apiType.OrderManagement,
            endpoint : `orders/requisition/reasonCodes`,
            apiMethod : apiMethod.GET,
            payload : null
            
        }
        yield put(globalLoaderText("Fetching Reason Code...."));

        const response = yield call(
            OrderManagementApiService.post,API_URL.PostWebApp,payloadData
            
        );

        if (response) {
            yield put(setRequisitionReasonCode(response));
            yield put(globalLoaderText(""));
        }

    } catch (error) {
        yield put(setRequisitionReasonCode([]))
        yield put(globalLoaderText(""));
    }
}

function* watchReasonCode() {
    yield takeEvery(GET_REASON_CODE, getReasonCode);
    yield takeEvery(GET_REQUISITION_REASON_CODE, getRequisitionReasonCode);
}

export default function* combinedSaga() {
    yield all([
        watchReasonCode()
    ])
}
